import { Candle } from '../chart/types';

// Exponential Moving Average over close prices.
// Returns an array aligned index-for-index with `candles`. Seeded with the
// first close so the line is continuous from bar 0 (no leading gap).
//
// This is the first module of the CCFOS indicator engine. Ported indicators
// (from the NT8 C# work) will live alongside it in src/indicators/ and share
// this same Candle-in → number[]-out shape, so the chart can overlay any of them.
export function ema(candles: Candle[], period: number): number[] {
  const k = 2 / (period + 1);
  const out: number[] = [];
  let prev = candles.length ? candles[0].close : 0;
  for (let i = 0; i < candles.length; i++) {
    const price = candles[i].close;
    prev = i === 0 ? price : price * k + prev * (1 - k);
    out.push(prev);
  }
  return out;
}
